import React, { useState } from 'react';

import { ReactComponent as EnterValue } from '../../../../assets/novosicones/Renegociacao/inventory_black_24dp.svg';

import { Item, ItemContent } from './styles.js';

import formatCurrent from '../../../../Utils/formatCurrent';

const ValorEntrada = ({ regras, setRegras, tema }) => {
  const [entrada, setEntrada] = useState('');

  const valueMask = (value) => {
    value = value.replace(/\D/g, '');
    // console.log("value", value);
    if (!value) {
      setEntrada('');
      return '';
    }
    // console.log("after if");
    const options = { minimumFractionDigits: 2 };
    const result = new Intl.NumberFormat('pt-BR', options).format(
      parseFloat(value) / 100
    );

    // console.log("restul", result);

    const pure = result.replace(/\D/g, '').padStart(3, '0');
    const sliceIndex = pure.length - 2;
    const decimal = pure.slice(0, sliceIndex) + '.' + pure.slice(sliceIndex);
    const decimalNumber = Number(decimal);
    // console.log("decimal", decimal);

    if (
      decimalNumber > Number(regras.valorTotal) ||
      decimalNumber > Number(regras?.valorMaximo?.toFixed(2))
    ) {
      return;
    }
    setEntrada(result);

    setRegras({ ...regras, entrada: decimalNumber });
  };

  let entradaValida = false;
  if (regras.entrada >= regras.valorMinimoEntrada) {
    entradaValida = true;
  }

  return (
    <Item>
      <span>
        <b>Valor da entrada:</b>
      </span>

      <ItemContent>
        <EnterValue
          className='iconeRenegociacao'
          fill={entradaValida ? tema.primaryColor : '#4d4d4d'}
        />

        <span
          style={
            !entrada
              ? { color: '#fff' }
              : entradaValida
              ? {
                  color: tema.primaryColor,
                }
              : { color: tema.accent }
          }
          className='currency'
        >
          R$
        </span>

        <input
          type='text'
          placeholder='*Digite o valor da sua entrada'
          value={entrada}
          onChange={(e) => valueMask(e.target.value)}
          style={
            entradaValida
              ? { color: tema.primaryColor }
              : { color: tema.accent }
          }
          id={'inputValorEntrada'}
        />
      </ItemContent>
      <span>
        <b>
          {`*O valor mínimo para a entrada é de ${formatCurrent(
            regras?.valorMinimoEntrada?.toFixed(2)
          )} e o valor máximo é de ${formatCurrent(
            regras?.valorMaximo?.toFixed(2)
          )}`}
        </b>
      </span>
    </Item>
  );
};

export default ValorEntrada;
